export default __webpack_public_path__ + "static/media/log4.5977443f.svg";